module.exports = "/assets/images/132ff8f18600d367bb7f976a6c24b1ba.svg";